import React from "react";
import OwlCarousel from "react-owl-carousel";
import "../../assets/styles/main.css";
import "../../assets/styles/responsive.css";
import bg from "../../assets/img/landingPageTestimonial.png";
import TestimonialSliderItem from "../testimonialSliderItem/testimonialSliderItem";
const LandingPageTestimonial = () => {
  
  const userDPsMale = [
    "https://randomuser.me/api/portraits/men/1.jpg",
    "https://randomuser.me/api/portraits/men/2.jpg",
    "https://randomuser.me/api/portraits/men/3.jpg",
];

const userDPsFemale = [
    "https://randomuser.me/api/portraits/women/1.jpg",
    "https://randomuser.me/api/portraits/women/2.jpg",
    "https://randomuser.me/api/portraits/women/3.jpg",
];

const data = [
    {
        dp: userDPsFemale[Math.floor(Math.random() * userDPsFemale.length)],
        userName: "Emily Johnson",
        companyName: "Innovate Solutions",
        review:
            "LeadBud has completely transformed our lead generation process! The intuitive interface and powerful automation tools have helped us double our qualified leads in just three months. It's a must-have tool for any business serious about growth!",
    },
    {
        dp: userDPsMale[Math.floor(Math.random() * userDPsMale.length)],
        userName: "Michael Chen",
        companyName: "NextGen Tech",
        review:
            "We were hesitant to try yet another lead generation tool, but LeadBud proved to be a game-changer. The real-time insights and seamless integration with our existing systems have been invaluable. Our sales team is now more productive than ever!",
    },
    {
        dp: userDPsFemale[Math.floor(Math.random() * userDPsFemale.length)],
        userName: "Sophia Martinez",
        companyName: "Martinez & Co.",
        review:
            "I can't recommend LeadBud enough! As a small business owner, I needed a reliable, cost-effective solution to find high-quality leads. LeadBud delivered beyond my expectations. The support team is fantastic too—always ready to assist!",
    },
    {
        dp: userDPsMale[Math.floor(Math.random() * userDPsMale.length)],
        userName: "Daniel Thompson",
        companyName: "Thompson Consulting",
        review:
            "LeadBud is the ultimate lead generation solution! The data accuracy and ease of use are unmatched. Since switching to LeadBud, we’ve seen a 40% increase in client acquisition. It’s a no-brainer investment for any business.",
    },
    {
        dp: userDPsFemale[Math.floor(Math.random() * userDPsFemale.length)],
        userName: "Rachel Adams",
        companyName: "Bright Marketing Agency",
        review:
            "LeadBud isn't just a tool—it's a growth partner. The advanced analytics and tailored lead recommendations have taken our marketing campaigns to a whole new level. We've saved hours of manual work and boosted conversions by 50%!",
    },
];


  const options = {
    dots: false,
    responsiveClass: true,
    loop: true,
    autoplay: true,
    smartSpeed: 300,
    autoplayTimeout: 2000,
    nav: true,
    navClass: "ss",
    navText: [
      '<i class="fa-solid fa-arrow-left" ></i>',
      '<i class="fa-solid fa-arrow-right"></i>',
    ],

    responsive: {
      0: {
        items: 1,
      },
      992: {
        items: 1.5,
      },
      1050: {
        items: 1.5,
      },
      1200: {
        items: 2.5,
      },
      1400: {
        items: 2.5,
      },
    },
  };

  return (
    <div
      className="section home-testimonials"
      style={{
        backgroundImage: `url('${bg}')`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        paddingTop: "188px",
        paddingBottom: "80px",
      }}
    >
      <div className="container-fluid">
        <div className="content-area padding-left">
          <h2 className="aos-item aos-inint aos-animate">
            What Other Customers
            <br />
            Says About Lead
          </h2>
        </div>

        <OwlCarousel className="owl-carousel padding-left" {...options}>
          {data.map((item, i) => (
            <TestimonialSliderItem
              key={i}
              userDP={item.dp}
              userName={item.userName}
              companyName={item.companyName}
              review={item.review}
            />
          ))}
        </OwlCarousel>
      </div>
    </div>
  );
};

export default LandingPageTestimonial;
